import { Search, X } from "lucide-react";

export const BrandSearchBar = ({ value, onChange, placeholder, count, testid, dark }) => (
  <div
    className={`flex items-center gap-3 w-full max-w-xl border-2 px-4 py-3 transition-colors focus-within:border-yellow-500 ${dark ? "bg-gray-900 border-gray-600" : "bg-white border-gray-950"}`}
    data-testid={`${testid}-wrap`}
  >
    <Search size={17} className={dark ? "text-yellow-500" : "text-gray-950"} />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testid}
      className={`w-full bg-transparent font-mono-tech text-sm focus:outline-none ${dark ? "text-white placeholder:text-gray-400" : "text-gray-950 placeholder:text-gray-500"}`}
    />
    {value && (
      <>
        <span className={`font-mono-tech text-[10px] shrink-0 ${dark ? "text-gray-400" : "text-gray-500"}`} data-testid={`${testid}-count`}>
          {count}
        </span>
        <button onClick={() => onChange("")} data-testid={`${testid}-clear`} className={dark ? "text-gray-400 hover:text-white" : "text-gray-500 hover:text-gray-950"}>
          <X size={15} />
        </button>
      </>
    )}
  </div>
);
